import {
  AggregationDone,
  AggregationModel,
  AggregationTodo,
} from "domains/models/AggregationModel";
import { EmployeeModel } from "domains/models/EmployeeModel";
import { UserModel } from "domains/models/UserModel";
import M5APIs from "m5/M5APIs";
import { action, computed, makeAutoObservable, observable } from "mobx";

class HomePageStore {
  @observable private _containers = [];
  @observable private _isLoading: boolean = false;
  @observable private _total = 0;
  @observable private _appraisee = 0;
  @observable private _employeeList: Array<EmployeeModel> = [];
  @observable private _tabValue: string = "downwards";

  @observable _currentAggregation?: AggregationModel;
  @observable _currentUser: EmployeeModel = {
    email: "",
    id: "",
    names: {
      fullname: "",
    },
    orgCode: "",
    paid: false,
    status: "",
    tier: "",
    username: "",
    userData: {
      deptName: "",
      jobTitle: "",
    },
  };
  @observable private _isOpenModal: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  async getDefaultDownwards(user: UserModel) {
    if (user.userData.jobTitleRank! === 11) {
      //과장.
      const response2 = await M5APIs.fetchUsers({
        page: 0,
        pageSize: 20000,
        where: JSON.stringify({
          filters: [
            {
              condition: "AND",
              field: "userData.`deptCode`",
              compare: "=",
              value: user.userData.deptCode,
            },
            {
              condition: "AND",
              field: "userData.`isDeleted`",
              compare: "=",
              value: false,
            },
          ],
        }),
      });

      // 나는 제외하고
      response2.users = response2.users.filter(
        (elUser: any) => elUser.id !== user.id
      );

      console.log("response2", response2.users);

      const downwardsIdList = response2.users
        .map((elUser: any) => {
          if (user.id !== elUser.id) {
            return {
              startedOn: "2023-01-03",
              id: elUser.id,
            };
          }
        })
        .filter((el: any) => el !== undefined);

      return downwardsIdList;
    } else if (user.userData.jobTitleRank! < 11) {
      // 과장 윗선..
      const response2 = await M5APIs.fetchUsers({
        page: 0,
        pageSize: 20000,
        where: JSON.stringify({
          filters: [
            {
              condition: "AND",
              field: "userData.`deptList[]`",
              compare: "IN",
              value: [user.userData.deptCode],
            },
            {
              condition: "AND",
              field: "ARRAY_COUNT(userData.`deptList`)",
              compare: ">",
              value: user.userData.deptList!.length,
            },
            {
              condition: "AND",
              field: "userData.`isDeleted`",
              compare: "=",
              value: false,
            },
          ],
        }),
      });

      if (response2.users === undefined) {
        return [];
      }

      console.log("[]getDefault", response2.users);

      const users: Array<UserModel> = [];

      const downwardsIdList =
        response2.users
          .map((elUser: any) => {
            if (user.id !== elUser.id) {
              users.push(elUser);
              return {
                startedOn: "2023-01-03",
                id: elUser.id,
              };
            }
          })
          .filter((el: any) => el !== undefined) || [];

      return users; //downwardsIdList;
    } else {
      return user.userData.downwardsList ?? [];
    }
  }

  @action
  async fetchTargetByEmail(email: string) {
    const response = await M5APIs.fetchUsers({
      fetchByFieldValue: "aggregationId",
      page: 0,
      pageSize: 20000,
      where: JSON.stringify({
        filters: [
          {
            condition: "AND",
            field: "email",
            compare: "=",
            value: email,
          },
        ],
      }),
    });

    if (response) {
      this._employeeList = response.users;
      this._total = response.total;
      this._isLoading = false;
    } else {
      this._employeeList = [];
      this._total = 0;
      this._isLoading = false;
      return { users: [] };
    }

    return response;
  }

  @action
  async fetchTargetByGraphId(graphId: string) {
    const response = await M5APIs.fetchUsers({
      fetchByFieldValue: "aggregationId",
      page: 0,
      pageSize: 20000,
      where: JSON.stringify({
        filters: [
          // {
          //   condition: "AND",
          //   field: "userData.`isDeleted`",
          //   compare: "=",
          //   value: false,
          // },
          {
            condition: "AND",
            field: "userData.`graphId`",
            compare: "=",
            value: graphId,
          },
        ],
      }),
    });

    if (response) {
      this._employeeList = response.users;
      this._total = response.total;
      this._isLoading = false;
    } else {
      this._employeeList = [];
      this._total = 0;
      this._isLoading = false;
      return { users: [] };
    }

    return response;
  }

  @action
  async fetchTargetsByDeptCode(userInfo: UserModel | undefined) {
    try {
      this._isLoading = true;
      let response;
      this._appraisee = 0;

      if (userInfo === undefined) {
        this._employeeList = [];
        this._total = 0;
        this._isLoading = false;
        return { users: [] };
      }

      if (this._tabValue === "downwards") {
        // console.log(toJS(userInfo));
        // const defaultsDownwards = (await this.getDefaultDownwards(userInfo!)) || [];
        // // response = {
        // //   users: defaultsDownwards
        // // };
        // const idList = defaultsDownwards.map((downward: any) => {
        //   return downward.id;
        // }) || [];
        // response = await M5APIs.fetchUsers({
        //   fetchByFieldValue: "aggregationId",
        //   page: 0,
        //   pageSize: 20000,
        //   where: JSON.stringify({
        //     filters: [
        //       {
        //         condition: "AND",
        //         field: "userData.`isDeleted`",
        //         compare: "=",
        //         value: false,
        //       },
        //       {
        //         condition: "AND",
        //         field: "meta().id",
        //         compare: "IN",
        //         value: idList ?? [],
        //       },
        //     ],
        //   }),
        // });
        // console.log(toJS(response));
        const defaultsDownwards =
          (await this.getDefaultDownwards(userInfo!)) || [];

        const orgDownwards =
          defaultsDownwards.map((downward: any) => {
            return downward.id;
          }) || [];

        let tempIdlist =
          userInfo?.userData.downwardsList?.map((li) => li.id) || [];
        const sumDownwards = [...orgDownwards, ...tempIdlist];
        const resultDownwards = sumDownwards.filter(
          (v, i) => sumDownwards.indexOf(v) === i
        );

        response = await M5APIs.fetchUsers({
          fetchByFieldValue: "aggregationId",
          page: 0,
          pageSize: 20000,
          where: JSON.stringify({
            filters: [
              {
                condition: "AND",
                field: "userData.`isDeleted`",
                compare: "=",
                value: false,
              },
              {
                condition: "AND",
                field: "meta().id",
                compare: "IN",
                value: resultDownwards ? resultDownwards : [],
              },
            ],
          }),
        });
      } else if (this._tabValue === "peer") {
        let tempIdlist = userInfo?.userData.peerList?.map((li) => {
          return li.id;
        });

        response = await M5APIs.fetchUsers({
          fetchByFieldValue: "aggregationId",
          page: 0,
          pageSize: 20000,
          where: JSON.stringify({
            filters: [
              {
                condition: "AND",
                field: "userData.`isDeleted`",
                compare: "=",
                value: false,
              },
              {
                condition: "AND",
                field: "meta().id",
                compare: "IN",
                value: tempIdlist ? tempIdlist : [],
              },
            ],
          }),
        });
      } else {
        // let tempIdlist1: any =
        //   userInfo?.userData.downwardsList?.map((li) => li.id) || [];
        // let tempIdlist2: any =
        //   userInfo?.userData.peerList?.map((li) => li.id) || [];
        // let tempIdlist = [...tempIdlist1, ...tempIdlist2, ...orgDownwards];
        // tempIdlist = tempIdlist.filter((v, i) => tempIdlist.indexOf(v) === i);

        //if (tempIdlist.length > 0) {
        response = await M5APIs.fetchUsers({
          fetchByFieldValue: "aggregationId",
          page: 0,
          pageSize: 20000,
          where: JSON.stringify({
            filters: [
              {
                condition: "AND",
                field: "userData.`isDeleted`",
                compare: "=",
                value: false,
              },
              {
                condition: "AND",
                field: "userData.jobTitleRank",
                compare: "<",
                value: 50,
              },
            ],
          }),
        });
        //}
      }

      if (response === undefined) {
        this._employeeList = [];
        this._total = 0;
        this._isLoading = false;
        return { users: [] };
      }

      //console.log(response);
      if (response.users) {
        for (let i = 0; i < response.users.length; i++) {
          for (let j = 0; j < response?.children?.length; j++) {
            if (
              response.users[i]?.userData.aggregationId ===
              response?.children[j].id
            ) {
              response.users[i].child = response?.children[j];
            }
          }
        }

        response.users.forEach((user: UserModel) => {
          this._currentAggregation?.userData.todoList?.forEach(
            (todo: AggregationTodo) => {
              if (user.id === todo.user) {
                if (todo.count > 0) {
                  this._appraisee = todo.count + this._appraisee;
                }
              }
            }
          );
        });

        let doneCount = 0;
        if (this._currentAggregation?.userData.doneList) {
          response.users.forEach((user: UserModel) => {
            this._currentAggregation?.userData.doneList?.forEach(
              (done: AggregationDone) => {
                if (user.id === done.user) {
                  if (done.count > 0) {
                    doneCount = done.count + doneCount;
                  }
                }
              }
            );
          });
        }
        this._appraisee = this._appraisee - doneCount;
      } else {
        this._employeeList = response?.users;
        this._total = response?.total;
        this._isLoading = false;
        return response;
      }

      response.users = response.users.map((user: EmployeeModel) => {
        user.displayCount = this.getCountEmployee(user);
        return user;
      });

      response.users = response.users.sort(
        (a: EmployeeModel, b: EmployeeModel) => {
          return b?.displayCount! - a?.displayCount!;
        }
      );

      if (response) {
        this._employeeList = response.users;
        this._total = response.total;
        this._isLoading = false;
      }

      return response;
    } catch (err) {
      throw err;
    } finally {
      this._isLoading = false;
    }
  }

  async fetchAggregaion(id: string) {
    return await M5APIs.fetchDocById(id, "", "AGGREGATION", {
      fetchLinkedIds: true,
    });
  }

  getCountEmployee = (employee: EmployeeModel) => {
    if (!this._currentAggregation?.userData.todoList) return 0;

    let countArr: AggregationTodo[] =
      this._currentAggregation?.userData.todoList?.filter(
        (todo: AggregationTodo) => {
          return todo?.user === employee.id;
        }
      );
    let doneCountArr: AggregationDone[];
    if (this._currentAggregation?.userData.doneList) {
      doneCountArr =
        this._currentAggregation?.userData.doneList?.filter(
          (done: AggregationDone) => {
            return done?.user === employee!.id;
          }
        ) ?? [];
    } else {
      doneCountArr = [];
    }

    if (countArr.length > 0 && doneCountArr.length > 0) {
      return countArr[0].count - doneCountArr[0].count;
    }
    if (countArr.length > 0) {
      return countArr[0].count;
    } else {
      return 0;
    }
  };

  @computed
  get employeeList() {
    return this._employeeList;
  }
  @computed
  get total() {
    return this._total;
  }
  @computed
  get appraisee() {
    return this._appraisee;
  }

  @action
  setIsOpenModal(isOpenModal: boolean) {
    this._isOpenModal = isOpenModal;
  }

  @action
  setCurrentUser(currentUser: EmployeeModel) {
    this._currentUser = currentUser;
  }
  @action
  setTabValue(tabValue: string) {
    this._tabValue = tabValue;
  }

  @action
  setCurrentAggregation(currentAggregation: AggregationModel) {
    this._currentAggregation = currentAggregation;
  }

  @computed
  get containers() {
    return this._containers;
  }

  @computed
  get currentAggregation() {
    return this._currentAggregation;
  }

  @computed
  get isEmpty() {
    return this._containers.length === 0;
  }

  @computed
  get isOpenModal() {
    return this._isOpenModal;
  }

  @computed
  get currentUser() {
    return this._currentUser;
  }
  @computed
  get isLoading() {
    return this._isLoading;
  }
  @computed
  get tabValue() {
    return this._tabValue;
  }
}

export default HomePageStore;
